'use client';

import { Form, Input, Button } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useLoginForm } from '@/contexts';
import type { FormEvent } from 'react';

export function LoginForm() {
  const { username, password, setUsername, setPassword, handleSubmit } = useLoginForm();

  const onSubmit = (e: FormEvent) => {
    handleSubmit(e);
  };

  return (
    <form onSubmit={onSubmit} className="space-y-4">
      <div>
        <Input
          size="large"
          prefix={<UserOutlined className="text-slate-400" />}
          placeholder="Username hoặc Email"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          className="rounded-2xl"
          required
        />
      </div>
      <div>
        <Input.Password
          size="large"
          prefix={<LockOutlined className="text-slate-400" />}
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="rounded-2xl"
          required
        />
      </div>
      <Button
        type="primary"
        size="large"
        htmlType="submit"
        className="w-full rounded-2xl bg-primary hover:bg-primary-dark"
        block
      >
        Đăng nhập
      </Button>
    </form>
  );
}
